<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import store from "@/state/store";

var state = store.state;
export default {
    page: {
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        PageHeader

    },
    data() {
        return {

            posSubscriptions: [],
            subscriptionPackages: [],
            page: 1,
            limit: 20,
            tot_pages: 0,
            searchHrLeaveTypes: null,
            PosSubscriptionsSearchMode: false,
            searchModel: "",
            state: state,
            pos_hub: [],
            pos_station: [],
            subscription_packages: [],
            subscription_packge: [],

        };
    },
    methods: {

        getPosHubs() {
            this.http.get(`pos-hubs`, null, null, true).then((res) => {
                this.pos_hub = res.data
                console.log('pos hub :', this.pos_hub)

            })
        },
        getPosStation() {
            this.http.get(`pos-stations`, null, null, true).then((res) => {
                this.pos_station = res.data

            })
        },
        getSubscriptionPackagePeriods() {
            this.http.get(`subscription-packages`, null, null, true).then((res) => {
                this.subscription_packages = res.data

            })
        },

        addPosSubscriptions() {
            var data = {
                title: "popups.add",
                inputs: [

                    {
                        model: "pos_station_id",
                        type: "select",
                        options: this.pos_station.map((e) => {
                            return { value: e.id, label: e.name }
                        }),
                        label: "pos_subscriptions.pos_station"
                    },

                    {
                        model: "type",
                        type: "select",
                        options: [

                            { value: 'm', label: this.$i18n.locale == 'ar' ? 'شهر' : 'Month' },
                            { value: 'm', label: this.$i18n.locale == 'ar' ? 'سنة' : 'year' }
                        ],


                        label: "pos_subscriptions.pos_station"
                    },


                    {
                        model: "subscription_packge_id",
                        type: "select",
                        options: this.subscription_packages.map((e) => {
                            return { value: e.id, label: e.name }
                        }),
                        label: "pos_subscriptions.subscription_packge"
                    },

                ],
                buttons: [
                    {
                        text: "popups.add",
                        closer: true,
                        color: "primary",
                        handler: (obj) => {
                            this.http.do("pos-subscriptions", obj).then((res) => {
                                if (res.status) {
                                    this.popup.alert({
                                        title: "",
                                        msg: 'popups.success',
                                    });
                                    this.get(this.page);
                                }
                            });
                        },
                    },
                    {
                        text: "popups.cancel",
                        closer: true,
                        color: "danger",
                        handler: () => {
                            console.log("Like Clicked");
                        },
                    },
                ],
            };
            this.popup.modal(data);
        },
        enable(app) {
            this.http.put(`pos-subscriptions/activate-subscriptions`, app.id).then((res) => {
                if (res.status) {

                    this.popup.alert({
                        title: "messages.success",
                        msg: 'pos_subscriptions.subscription_is_activated',
                    });
                    this.get(this.page)
                }
            })
        },
        disable(app) {
            this.http.put(`pos-subscriptions`, app.id, { is_active: 0 }).then(() => {
                this.get(this.page)
            })
        },
        editPosSubscriptions(app) {
            var data = {
                title: "popups.edit",
                inputs: [

                    {
                        label: "pos_subscriptions.period",
                        type: "text",
                        model: "period",
                        value: app.period
                    },


                    // { model: "icon", type: "file", label: "pos_subscriptions.icon" },
                    {
                        model: "subscription_packge_id",
                        type: "select",
                        options: this.subscription_packages.map((e) => {
                            return { value: e.id, label: e.name }
                        }),
                        label: "pos_subscriptions.subscription_packge",
                        value: app.subscription_packge_id
                    },

                ],
                buttons: [
                    {
                        text: "popups.edit",
                        closer: true,
                        color: "primary",
                        handler: (obj) => {
                            this.http.put("pos-subscriptions", app.id, obj).then((res) => {
                                if (res.status) {
                                    this.popup.alert({
                                        title: "",
                                        msg: 'popups.success',
                                    });
                                    this.get(this.page);
                                }
                            });
                        },
                    },
                    {
                        text: "popups.cancel",
                        closer: true,
                        color: "danger",
                        handler: () => {
                            console.log("Like Clicked");
                        },
                    },
                ],
            };
            this.popup.modal(data);
        },
        search() {
            this.PosSubscriptionsSearchMode = true;
            this.tot_pages = 0;
            this.http
                .post("pos-subscriptions/search", {
                    search: this.searchModel,
                    limit: this.limit,
                    page: this.page,
                    col: "name",
                })
                .then((res) => {
                    this.posSubscriptions = res.data;
                });
        },
        cancelappsearchMode() {
            this.searchModel = "";
            this.PosSubscriptionsSearchMode = false;
            this.get(this.page);
        },


        deletePosSubscriptions(app) {
            var data = {
                title: "popups.delete",
                msg: "popups.delmessage",
            };
            this.popup.confirm(data).then((resp) => {
                if (resp) {
                    this.http.delete("pos-subscriptions", app.id).then(() => {
                        this.get(this.page);
                    });
                }
            });
        },

        get(page) {
            console.log(page);
            this.http
                .post("pos-subscriptions/paginate", {
                    limit: this.limit,
                    page: page,
                    active: false

                })
                .then((res) => {
                    this.page = page;
                    this.tot_pages = Math.ceil(res.tot / this.limit);
                    this.posSubscriptions = res.data;
                });
        },
    },
    created() {
        this.get(1);
    },
    mounted() {
        this.getPosStation(),
            this.getSubscriptionPackagePeriods(),
            this.getPosHubs()


    },
};
</script>

<template>
    <PageHeader :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
        :title="$t('menu.menuitems.pos_subscription_management.subItems.requests')" />

    <div class="row">
        <div class="col-6">
            <!-- <div class="search-box chat-search-box w-50">
                        <div class="position-relative">
                            <input @keyup="search()" type="text" class="form-control fa-lg text-light"
                                :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" :placeholder="$t('popups.search')"
                                v-model="searchModel" style="background-color: #2a3042 !important" />
                            <i class="bx bx-search-alt search-icon text-light"></i>
                        </div>
                    </div> -->
        </div>
        <div class="col-6" style="display: flex; justify-content: flex-end">
            <button class="btn-close text-light" v-if="PosSubscriptionsSearchMode" @click="cancelappsearchMode()"></button>
            <button type="button" @click="addPosSubscriptions()" class="btn btn-light float-end mb-4">
                <span class="bx bxs-plus-circle float-end fa-2x" style="color: #2a3042 !important"></span>
            </button>
        </div>
    </div>

    <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
        <thead>
            <tr class="text-light text-center" style="background-color: #2a3042 !important">
                <th scope="col">{{ $t("pos_subscriptions.id") }}</th>
                <th scope="col">{{ $t("pos_subscriptions.pos_station") }}</th>
                <th scope="col">{{ $t("pos_subscriptions.subscription_packge") }}</th>
                <th scope="col">{{ $t("pos_subscriptions.period") }}</th>
                <th scope="col">{{ $t("pos_subscriptions.type") }}</th>
                <th scope="col">{{ $t("pos_subscriptions.created") }}</th>
                <th scope="col">{{ $t("pos_subscriptions.is_active") }}</th>
                <th scope="col">{{ $t("pos_subscriptions.operations") }}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(app, index) in posSubscriptions" :key="index" class="text-center">
                <td>{{ index + 1 }}</td>
                <td>{{ app?.pos_station_name }}</td>
                <td>{{ $i18n.locale == "en" ? app?.name_en : app?.name }}</td>
                <td>{{ app?.period }}</td>
                <td>{{ app?.type == "m" && app?.period > 1 ? $t('pos_subscriptions.months') : app?.type == "m" &&
                    app?.period
                    == 1 ? $t('pos_subscriptions.month') : app?.type == "y" && app?.period > 1 ?
                    $t('pos_subscriptions.years') : $t('pos_subscriptions.year') }}</td>
                <td>{{ new Date(app?.created).toLocaleString('en-GB') }}</td>


                <td>
                    <button @click="enable(app)" class="btn btn-success"> {{ this.$t("popups.accept") }}</button>

                </td>


                <td class="d-flex">
                    <a class="btn btn-primary mx-1" @click="editPosSubscriptions(app)" href="javascript: void(0);"
                        role="button">{{ $t("popups.edit") }}</a>

                    <a class="btn btn-danger mx-1" @click="deletePosSubscriptions(app)" href="javascript: void(0);"
                        role="button">{{ $t("popups.delete") }}</a>

                </td>

            </tr>
        </tbody>
    </table>
    <!-- end  table -->
    <!-- Button trigger modal -->

    <div>
        <!--   Apps  Pagination     -->
        <ul class="pagination pagination-rounded justify-content-center mb-2">
            <li class="page-item" :class="{ disabled: page == 1 }">
                <a class="page-link" href="javascript: void(0);" @click="get(page - 1)" aria-label="Previous">
                    <i class="mdi mdi-chevron-left"></i>
                </a>
            </li>
            <li class="page-item" :class="{ active: p == page }" v-for="p in tot_pages" :key="p">
                <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
                    p
                }}</a>
            </li>

            <li class="page-item" :class="{ disabled: page == tot_pages }">
                <a class="page-link" href="javascript: void(0);" @click="get(page + 1)" aria-label="Next">
                    <i class="mdi mdi-chevron-right"></i>
                </a>
            </li>
        </ul>
    </div>

    <!--end-->
</template>

<style scoped>
.btn-close {
    position: relative;
    right: 317px;
    top: 6px;
    font-size: 15px;
}
</style>
